import { render, staticRenderFns } from "./ChatOrderVoucher.vue?vue&type=template&id=77d1700d&scoped=true&"
import script from "./ChatOrderVoucher.vue?vue&type=script&lang=js&"
export * from "./ChatOrderVoucher.vue?vue&type=script&lang=js&"
import style0 from "./ChatOrderVoucher.vue?vue&type=style&index=0&id=77d1700d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d1700d",
  null
  
)

export default component.exports